import React, { useState } from "react";
import firebase from "firebase/app";
import { useHistory } from "react-router-dom";

import "./styles.css";
import CustomInput from "../../components/auth/CustomInput";
import Button from "../../components/Button";
import { login, resendVerificationEmail } from "../../util/Auth";

import appStoreBadge from "../../static/img/app-store-badge.png";
import googlePlayBadge from "../../static/img/google-play-badge.jpg";
import Footer from "../../components/Footer";

export default function LoginScreen() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showVerificationButton, setShowVerificationButton] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.currentTarget.value);
    setShowVerificationButton(false);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.currentTarget.value);
    setShowVerificationButton(false);
  };

  let userLogin = () => {
    login(email, password)
      .then((success) => {
        if (success) {
          // Dispatch a custom event that NavBar can listen for
          window.dispatchEvent(new Event("userLogin"));
          history.push("/dashboard");
        }
      })
      .catch((error) => {
        if (error.message === "EMAIL_NOT_VERIFIED") {
          setShowVerificationButton(true);
          alert(
            "Please verify your email address before logging in. Check your inbox for the verification email."
          );
        } else {
          alert("Invalid email or password");
        }
      });
  };

  const handleResendVerification = () => {
    resendVerificationEmail().then(() => {
      setShowVerificationButton(false);
    });
  };

  const handleForgotPassword = async () => {
    const emailToReset = email.trim();
    if (!emailToReset) {
      alert("Please enter your email address above to reset your password.");
      return;
    }
    try {
      await firebase.auth().sendPasswordResetEmail(emailToReset);
      alert("A password reset email has been sent. Please check your inbox.");
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        alert("No user found with that email address.");
      } else if (error.code === "auth/invalid-email") {
        alert("Invalid email address.");
      } else {
        alert("Failed to send password reset email. Please try again later.");
      }
    }
  };

  return (
    <div className="LoginScreen">
      <h1>Login</h1>

      <form className="form">
        <CustomInput
          labelText="Email"
          id="email"
          formControlProps={{
            fullWidth: true
          }}
          handleChange={handleEmailChange}
          type="text"
        />
        <CustomInput
          labelText="Password"
          id="password"
          formControlProps={{
            fullWidth: true
          }}
          handleChange={handlePasswordChange}
          type="password"
        />

        <div style={{ textAlign: "right", marginBottom: 10 }}>
          <button
            type="button"
            className="link-button"
            style={{
              background: "none",
              border: "none",
              color: "#007bff",
              textDecoration: "underline",
              cursor: "pointer",
              padding: 0
            }}
            onClick={handleForgotPassword}
          >
            Forgot Password?
          </button>
        </div>

        <Button
          onClick={userLogin}
          type="button"
          color="primary"
          className="form__custom-button"
        >
          Log in
        </Button>

        {showVerificationButton && (
          <Button
            onClick={handleResendVerification}
            type="button"
            color="secondary"
            className="form__custom-button"
            style={{ marginTop: "10px" }}
          >
            Resend Verification Email
          </Button>
        )}

        <Button
          onClick={() => history.push("/create-account")}
          type="button"
          color="secondary"
          className="form__custom-button"
          style={{ marginTop: "10px" }}
        >
          Create Account
        </Button>
      </form>

      <p style={{ width: "80%", margin: "0 auto" }}>Or</p>

      <div style={{ paddingBottom: 50 }}>
        <a href="https://apps.apple.com/us/app/808-cleanups/id1464605740">
          <img
            src={appStoreBadge}
            style={{ margin: 10 }}
            alt="appStore"
            width="25%"
          ></img>
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.app808cleanups&hl=en_US">
          <img
            src={googlePlayBadge}
            style={{ margin: 10 }}
            alt="playStore"
            width="25%"
          ></img>
        </a>
      </div>
      <Footer />
    </div>
  );
}
